let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bapkj")).then(() => parcelRequire('kafvk'));